<template>
<path d="M5.5 3.5L2.5 6.5L5.5 9.5M2.75 6.5H9.5C11.433 6.5 13 8.067 13 10C13 11.933 11.433 13.5 9.5 13.5H7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
</template>
